import React, { useState } from 'react';

const links = {
  Products: [
    { label: 'RUSH', href: '/products/rush' },
    { label: 'SYNAPTIQ', href: '/products/synaptiq' },
    { label: 'VITRA', href: '/products/vitra' },
  ],
  Company: [
    { label: 'About Us', href: '/about' },
    { label: 'Our Science', href: '/science' },
    { label: 'Blog', href: '/blog' },
    { label: 'Contact', href: '/contact' },
  ],
  Support: [
    { label: 'Shipping & Returns', href: '/shipping' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Subscribe & Save', href: '/subscribe' },
  ],
};

const socials = [
  {
    label: 'Instagram',
    href: 'https://instagram.com/berletohealth',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    label: 'TikTok',
    href: 'https://tiktok.com/@berletohealth',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.79 1.53V6.75a4.85 4.85 0 01-1.02-.06z" />
      </svg>
    ),
  },
];

export function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (email) setSubmitted(true);
  }

  return (
    <footer style={{ background: '#1A2A1A' }} data-bubble-theme="light">

      {/* Top brand statement */}
      <div
        className="border-b px-6 py-16 md:py-24"
        style={{ borderColor: 'rgba(232,220,196,0.1)' }}
      >
        <div className="container mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-end">

            {/* Wordmark + tagline */}
            <div>
              <p
                className="text-xs font-medium tracking-[0.3em] uppercase mb-6"
                style={{ color: '#B8704D' }}
              >
                Berleto
              </p>
              <h2
                className="text-4xl md:text-6xl font-light leading-tight"
                style={{ color: '#FAF9F6' }}
              >
                Elevated wellness
                <br />
                <span style={{ color: 'rgba(232,220,196,0.45)' }}>
                  through nature's
                  <br />
                  intelligence.
                </span>
              </h2>
            </div>

            {/* Newsletter */}
            <div className="md:text-right">
              <p
                className="text-sm mb-2"
                style={{ color: 'rgba(232,220,196,0.6)' }}
              >
                Join 12,000+ optimizers.
              </p>
              <p
                className="text-xs tracking-widest uppercase mb-6"
                style={{ color: 'rgba(139,154,139,0.7)' }}
              >
                Science, protocols & early access — no noise.
              </p>

              {submitted ? (
                <p className="text-sm" style={{ color: '#B8704D' }}>
                  You're in. Welcome to Berleto.
                </p>
              ) : (
                <form onSubmit={handleSubmit} className="flex gap-2 md:justify-end">
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                    className="bg-transparent text-sm px-4 py-2.5 rounded-lg outline-none w-56 placeholder:text-[rgba(139,154,139,0.5)] focus:border-[rgba(232,220,196,0.4)] transition-colors"
                    style={{
                      border: '1px solid rgba(232,220,196,0.15)',
                      color: '#FAF9F6',
                    }}
                  />
                  <button
                    type="submit"
                    className="text-sm font-medium px-5 py-2.5 rounded-lg transition-opacity hover:opacity-80 flex-shrink-0"
                    style={{ background: '#B8704D', color: '#FAF9F6' }}
                  >
                    Join
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Link columns */}
      <div
        className="border-b px-6 py-14"
        style={{ borderColor: 'rgba(232,220,196,0.1)' }}
      >
        <div className="container mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
            {Object.entries(links).map(([category, items]) => (
              <div key={category}>
                <p
                  className="text-xs font-medium tracking-[0.2em] uppercase mb-5"
                  style={{ color: 'rgba(139,154,139,0.6)' }}
                >
                  {category}
                </p>
                <ul className="space-y-3">
                  {items.map(item => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        className="text-sm transition-colors duration-200 hover:opacity-100"
                        style={{ color: 'rgba(232,220,196,0.55)' }}
                        onMouseEnter={e => (e.target.style.color = '#FAF9F6')}
                        onMouseLeave={e => (e.target.style.color = 'rgba(232,220,196,0.55)')}
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* Social */}
            <div>
              <p
                className="text-xs font-medium tracking-[0.2em] uppercase mb-5"
                style={{ color: 'rgba(139,154,139,0.6)' }}
              >
                Follow
              </p>
              <div className="flex flex-col gap-3">
                {socials.map(s => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-sm transition-colors duration-200 group"
                    style={{ color: 'rgba(232,220,196,0.55)' }}
                    onMouseEnter={e => {
                      e.currentTarget.style.color = '#FAF9F6';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.color = 'rgba(232,220,196,0.55)';
                    }}
                  >
                    {s.icon}
                    {s.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="px-6 py-6">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-3">
          <p
            className="text-xs"
            style={{ color: 'rgba(139,154,139,0.5)' }}
          >
            &copy; {new Date().getFullYear()} Berleto. All rights reserved.
          </p>
          <div
            className="flex items-center gap-5 text-xs"
            style={{ color: 'rgba(139,154,139,0.5)' }}
          >
            <a href="/privacy" className="hover:opacity-100 transition-opacity" style={{ color: 'inherit' }}>Privacy</a>
            <a href="/terms" className="hover:opacity-100 transition-opacity" style={{ color: 'inherit' }}>Terms</a>
            <span>
              Designed by{' '}
              <a
                href="https://pixylmedia.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors"
                style={{ color: 'rgba(184,112,77,0.7)' }}
                onMouseEnter={e => (e.target.style.color = '#B8704D')}
                onMouseLeave={e => (e.target.style.color = 'rgba(184,112,77,0.7)')}
              >
                Pixylmedia
              </a>
            </span>
          </div>
        </div>
      </div>

    </footer>
  );
}
